import { Link } from 'react-router-dom';
import { useLang } from '../i18n/context';
import { primaryCommunity } from '../data/communityData';
import { ROUTES } from '../routes/routeConfig';
import './CommunityBanner.css';

// 社群宣传卡：黑金毛玻璃横幅，点击跳站内 DeBox 社群介绍页 /community（不再直接外链）。
function CommunityBanner() {
  const { t } = useLang();
  const group = primaryCommunity;

  return (
    <Link className="community-banner" to={ROUTES.community}>
      <img className="community-banner-logo" src={group.logo} alt="" />
      <div className="community-banner-text">
        <span className="community-banner-kicker">{t('community.kicker')}</span>
        <h3>{t('community.bannerTitle')}</h3>
        <p>{t('community.bannerDesc')}</p>
      </div>
      <span className="community-banner-btn">{t('community.joinLabel')} →</span>
    </Link>
  );
}

export default CommunityBanner;
